














































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ApiError, Extra, ExtraVariation } from '@/api';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import QuickEditVariation from '@/components/admin/QuickEditVariation.vue';
import CurrencyField from '@/components/CurrencyField.vue';

@Component({
  components: {
    AbstractTable,
    ConfirmDialog,
    QuickEditVariation,
    CurrencyField,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  extra: Extra | null = null;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get extraId() {
    return this.$route.params.extraId;
  }

  get variationHeaders() {
    return ExtraVariation.listHeaders();
  }

  get variationScope() {
    return () =>
      ExtraVariation.includes(['vehicleType']).where({ extra: this.extraId });
  }

  update() {
    (this.$refs.variationTable as AbstractTable).update();
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.extra && this.extra.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.extra) {
      return;
    }

    try {
      await this.extra.save();
      if (
        this.$route.name === 'admin-extras-add' &&
        this.extra &&
        this.extra.id
      ) {
        this.$router.push({
          name: 'admin-extras-edit',
          params: { extraId: this.extra.id },
        });
        snackModule.showSnackbar('Extra Created');
      } else {
        snackModule.showSnackbar('Extra Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-extras-edit' && this.extraId) {
      try {
        this.extra = (await Extra.find(this.extraId)).data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Extra not found');
      }
    } else {
      this.extra = new Extra();
      this.extra.reset();
    }
  }
}
